import { ArrowRightOutlined } from '@ant-design/icons'
import { styled, FontWeight, media, H3Alternate, Body } from '@thesisedu/web/dist'
import { graphql, useStaticQuery, Link } from 'gatsby'
import React from 'react'

import { PRODUCT_NAME } from './constants'
import { HoverBrochureCardSmall } from './styled'

export const featuredContentQuery = graphql`
  query kbFeaturedContent {
    allSanityArticle(
      sort: { order: [ASC], fields: [featuredWeight] }
      filter: { featuredWeight: { ne: null } }
    ) {
      edges {
        node {
          id
          products
          name
          featuredWeight
          slug {
            current
          }
        }
      }
    }
  }
`

export function FeaturedContent() {
  const data = useStaticQuery(featuredContentQuery)
  const featured = data.allSanityArticle.edges
    .map(edge => edge.node)
    .filter(node => node.featuredWeight !== null && node.products.includes(PRODUCT_NAME))
    .map(node => (
      <div key={node.id}>
        <SupportArticleCard title={node.name} slug={node.slug.current} />
      </div>
    ))
  return <Container>{featured}</Container>
}

export function SupportArticleCard({ title, slug }) {
  return (
    <Card as={Link} to={slug}>
      <H3Alternate weight={FontWeight.SemiBold}>{title}</H3Alternate>
      <Body color={'@primary-color'}>
        Read article <ArrowRightOutlined />
      </Body>
    </Card>
  )
}

const Card = styled(HoverBrochureCardSmall)`
  padding: ${props => props.theme['@size-s']};
  width: 100%;
  height: 100%;
`

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -${props => props.theme['@size-s']};
  align-items: stretch;
  justify-content: flex-start;
  > div {
    display: flex;
    align-items: stretch;
    justify-content: stretch;
    height: 100%;
    width: 100%;
    padding: ${props => props.theme['@size-s']};
    ${media.md} {
      width: 50%;
    }
    ${media.lg} {
      width: 33%;
    }
    ${media.xl} {
      width: 25%;
    }
  }
`
